import React from "react";
import Head from "next/head";
import DiscoveryFlow from "../../components/Discovery/DiscoveryFlow";
import discoveryConfig from "../../components/Discovery/config";

export default function DiscoveryIndexPage() {
  return (
    <>
      <Head>
        <title>Discovery</title>
      </Head>
      <DiscoveryFlow config={discoveryConfig} />
    </>
  );
}
